// IELTS Mock 2 — Academic Speaking (harder than Mock 3: more abstract Part 3)
// Same shape as IELTS_DATA_SPEAKING in ../IeltsSpeaking.js.
const IELTS_MOCK2_SPEAKING = {
  title: "Academic Speaking Practice Test 2",
  parts: [
    {
      id: "part1",
      title: "Part 1: Introduction & Interview (4-5 min)",
      questions: [
        "Let's talk about music. What kind of music do you enjoy listening to?",
        "Has your taste in music changed as you have got older?",
        "Let's talk about photographs. Do you enjoy taking photographs? Why or why not?",
        "Do you prefer to keep photos on your phone or to print them?",
        "Is there a photograph in your home that is especially important to you?"
      ]
    },
    {
      id: "part2",
      title: "Part 2: Long Turn (Cue Card) (3-4 min)",
      prompt: "Describe a time when you had to change your plans unexpectedly. You should say: What you had planned to do, Why you had to change your plans, What you did instead, and explain how you felt about this change.",
      preparationTime: 60,
      speakingTime: 120
    },
    {
      id: "part3",
      title: "Part 3: Discussion (4-5 min)",
      questions: [
        "Why do some people find it difficult to adapt when their plans change?",
        "Do you think people today plan their lives more carefully than people did in the past?",
        "How has technology changed the way people make and change plans?",
        "Should governments focus more on long-term planning or on solving immediate problems? Why?"
      ]
    }
  ]
};

export default IELTS_MOCK2_SPEAKING;
